import { get, post } from '../client'
import type { ReferralOverview } from '../types/referrals'

export async function getReferralOverview(): Promise<ReferralOverview> {
  return get<ReferralOverview>('api/candidate/referrals')
}

export async function bindReferral(code: string): Promise<{ ok: boolean }> {
  return post<{ ok: boolean }>('api/candidate/referrals/bind', { code })
}

export async function inviteByEmail(email: string): Promise<{ ok: boolean }> {
  return post<{ ok: boolean }>('api/candidate/referrals/invite', { email })
}
